package com.daytimegaming.ourdailyfinances.presentation.components

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.material3.adaptive.currentWindowAdaptiveInfo
import androidx.compose.runtime.Composable
import androidx.window.core.layout.WindowSizeClass.Companion.WIDTH_DP_EXPANDED_LOWER_BOUND
import com.daytimegaming.ourdailyfinances.presentation.util.isExpandedWidth
import com.daytimegaming.ourdailyfinances.presentation.util.isMediumWidth

@Composable
fun AdaptiveWindowLayout(
    compactMediumContent: @Composable () -> Unit,
    expandedContent: @Composable () -> Unit
) {
    val adaptiveInfo = currentWindowAdaptiveInfo()

    BoxWithConstraints {
        if (adaptiveInfo.windowSizeClass.isWidthAtLeastBreakpoint(WIDTH_DP_EXPANDED_LOWER_BOUND)) {
            expandedContent()
        } else {
            compactMediumContent()
        }
    }
}

@Composable
fun AdaptiveWindowLayout(
    compactContent: @Composable () -> Unit = {},
    mediumContent: @Composable () -> Unit = {},
    expandedContent: @Composable () -> Unit = {},
) {
    val adaptiveInfo = currentWindowAdaptiveInfo()

    BoxWithConstraints {
        if (adaptiveInfo.windowSizeClass.isExpandedWidth()) {
            expandedContent()
        } else if (adaptiveInfo.windowSizeClass.isMediumWidth()) {
            mediumContent()
        } else {
            compactContent()
        }
    }
}